import React from 'react';
import { Link } from 'react-router-dom';

const COLORS = { black: '#0A0A0A', white: '#F5F5F0', gold: '#C9A84C', gray: '#888' };

// TODO(M2): Replace with API fetch from GET /api/products
export const PRODUCTS = [
  {
    id: 'p001',
    slug: 'qr-tee',
    name: 'QR TEE',
    price: 89,
    tagline: 'The essential. Oversized, heavy cotton, your code front and center.',
    qrCodePreview: null,
    category: 'tops',
    available: true,
  },
  {
    id: 'p002',
    slug: 'qr-hoodie',
    name: 'QR HOODIE',
    price: 149,
    tagline: 'French terry. Dropped shoulders. A 4×4 QR on the back — scannable from across the room.',
    qrCodePreview: null,
    category: 'tops',
    available: true,
  },
  {
    id: 'p003',
    slug: 'qr-cap',
    name: 'QR CAP',
    price: 59,
    tagline: 'Six-panel, unstructured. QR patch on the front. Understated and effective.',
    qrCodePreview: null,
    category: 'accessories',
    available: true,
  },
  {
    id: 'p004',
    slug: 'qr-tote',
    name: 'QR TOTE',
    price: 45,
    tagline: 'Heavy canvas. One QR, one handle, zero noise. The entry point to QRQY.',
    qrCodePreview: null,
    category: 'accessories',
    available: false,
  },
];

function QRPlaceholder({ size = 120 }) {
  return (
    <div style={{
      width: size,
      height: size,
      border: `2px solid ${COLORS.white}`,
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gridTemplateRows: 'repeat(5, 1fr)',
      gap: '2px',
      padding: '8px',
      flexShrink: 0,
    }}>
      {/* Simplified QR visual stand-in */}
      {Array.from({ length: 25 }).map((_, i) => {
        // Roughly mimic QR finder pattern corners + noise
        const isCorner = [0,1,5,6,4,9,20,21,25,24].includes(i);
        const isRandom = Math.sin(i * 7.3) > 0.1;
        return (
          <div
            key={i}
            style={{
              backgroundColor: (isCorner || isRandom) ? COLORS.white : 'transparent',
            }}
          />
        );
      })}
    </div>
  );
}

function ProductCard({ product }) {
  return (
    <article style={{
      display: 'flex',
      flexDirection: 'column',
      gap: '1.5rem',
      padding: '2rem',
      border: `1px solid rgba(255,255,255,0.1)`,
      transition: 'border-color 0.2s',
      position: 'relative',
    }}>
      {!product.available && (
        <div style={{
          position: 'absolute',
          top: '1rem',
          right: '1rem',
          fontSize: '0.65rem',
          letterSpacing: '0.15em',
          color: COLORS.gold,
          fontWeight: 700,
          border: `1px solid ${COLORS.gold}`,
          padding: '0.25rem 0.5rem',
        }}>
          SOLD OUT
        </div>
      )}

      {/* QR code stand-in */}
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '2rem',
        backgroundColor: 'rgba(255,255,255,0.02)',
        aspectRatio: '1',
        minHeight: '200px',
      }}>
        <QRPlaceholder size={140} />
      </div>

      {/* Product info */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.5rem' }}>
        <h3 style={{
          margin: 0,
          fontSize: '0.85rem',
          fontWeight: 800,
          letterSpacing: '0.15em',
          color: COLORS.white,
        }}>
          {product.name}
        </h3>
        <p style={{
          margin: 0,
          fontSize: '0.82rem',
          color: COLORS.gray,
          lineHeight: 1.6,
          fontFamily: 'Georgia, serif',
          fontStyle: 'italic',
        }}>
          {product.tagline}
        </p>
        <p style={{
          margin: 0,
          fontSize: '1rem',
          fontWeight: 700,
          color: COLORS.white,
          marginTop: '0.5rem',
        }}>
          ${product.price}
        </p>
      </div>

      {product.available ? (
        <Link
          to={`/shop/${product.slug}`}
          style={{
            display: 'block',
            textAlign: 'center',
            padding: '0.85rem',
            backgroundColor: 'transparent',
            border: `1px solid ${COLORS.white}`,
            color: COLORS.white,
            textDecoration: 'none',
            fontSize: '0.72rem',
            fontWeight: 700,
            letterSpacing: '0.2em',
            transition: 'background-color 0.15s, color 0.15s',
          }}
        >
          VIEW PRODUCT
        </Link>
      ) : (
        <div style={{
          textAlign: 'center',
          padding: '0.85rem',
          backgroundColor: 'transparent',
          border: `1px solid rgba(255,255,255,0.2)`,
          color: 'rgba(255,255,255,0.3)',
          fontSize: '0.72rem',
          fontWeight: 700,
          letterSpacing: '0.2em',
        }}>
          NOTIFY ME
        </div>
      )}
    </article>
  );
}

export default function Categories() {
  return (
    <div style={{ maxWidth: '1400px', margin: '0 auto', padding: '4rem 2rem' }}>
      {/* Header */}
      <div style={{ marginBottom: '4rem' }}>
        <p style={{
          fontSize: '0.7rem',
          letterSpacing: '0.25em',
          color: COLORS.gold,
          marginBottom: '0.75rem',
          fontWeight: 600,
        }}>
          SEASON 01
        </p>
        <h1 style={{
          fontSize: 'clamp(2.5rem, 6vw, 5rem)',
          fontWeight: 900,
          letterSpacing: '-0.02em',
          lineHeight: 0.95,
          color: COLORS.white,
          margin: 0,
        }}>
          THE DROP
        </h1>
        <p style={{
          marginTop: '1.5rem',
          fontSize: '0.9rem',
          color: COLORS.gray,
          fontFamily: 'Georgia, serif',
          fontStyle: 'italic',
          maxWidth: '500px',
          lineHeight: 1.7,
        }}>
          Each piece ships with a unique QR code. Your account activates it.
        </p>
      </div>

      {/* Product grid */}
      {/* TODO(M2): Replace PRODUCTS const with API fetch */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
        gap: '1px',
        backgroundColor: 'rgba(255,255,255,0.08)',
      }}>
        {PRODUCTS.map((product) => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
    </div>
  );
}
